import {Inject, Injectable} from "@angular/core";
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from "@angular/common/http";
import {catchError, Observable} from "rxjs";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";
import { ClientService } from "./authentication/client.service";


@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {

	constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth, private clientService: ClientService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const AUTH_TOKEN = this.oktaAuth.getAccessToken();
		const serviceName = req.url.split('/')[1];
		let headerValue = '';
		switch(serviceName) {
			case 'crfs-security':
				headerValue = 'application/vnd.crs.crfs.security.v1+json';
				break;
			default:
				headerValue = 'application/vnd.crs.crfs.cfm.v1+json';
		}
		req = req.clone({setHeaders: {
			'Accept': headerValue,
			'Content-type': headerValue,
			'Authorization': `Bearer ${AUTH_TOKEN}`
		}});
		if(this.clientService.getRole()['CRFS_CRS_ADMIN_ROLE'] || this.clientService.getRole()['CRFS_CRS_SUPPORT_ROLE']) {
			req = req.clone({setHeaders: {
				'tenantName': this.clientService.getTenantName(),
			}});
		}
		return next.handle(req);
	}
}